import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import FlowSimulatorView from './views/FlowSimulatorView';

export const flowSimulatorRoutes: RouteObject[] = [
    {
        path: '/dev/flow-simulator',
        element: <FlowSimulatorView />,
        errorElement: <ErrorBoundary />,
    },
];
